import { memo } from "react";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { FormFieldProps } from "./types";
import { useTranslation } from "react-i18next";

const SwitchField = memo(({ config, control }: FormFieldProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full">
      <FormField
        control={control}
        name={config.name}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <div className="items-center flex gap-1">
                <Switch
                  id={field.name}
                  {...field}
                  checked={field.value}
                  onCheckedChange={(e: any) => field.onChange(e)}
                />
                <Label
                  htmlFor={field.name}
                  className="text-slate-700 text-sm font-medium font-['Raleway'] leading-normal"
                >
                  {t(config.label ?? config.name)}
                </Label>
              </div>
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
});

SwitchField.displayName = "SwitchField";
export default SwitchField;
